import {Component, Input, OnChanges} from '@angular/core';
import {OrderStatusEnum} from '@libs-enums/status.enum';
import {Order} from '@libs-classes/order.class';
import {NgClass} from '@angular/common';

@Component({
    selector: 'app-tasks-count',
    standalone: true,
    imports: [
        NgClass
    ],
    templateUrl: './tasks-count.component.html',
    styleUrl: './tasks-count.component.scss'
})
export class TasksCountComponent implements OnChanges{
    @Input() workerTasks?: Order[];
    @Input() allWorkersTasks?: Order[];
    allTasks: Order[] = [];

    ordersStatusCount: { [key: string]: number } = {
        done: 0,
        ready: 0,
        onway: 0,
        reject: 0,
        atwork: 0,
        destributed: 0,
    };

    /**
     * Подсчитывает количество заказов по их статусам.
     */
    calculateStatusOrdersCount(): void {
        if(this.workerTasks) {
            this.allTasks = this.workerTasks;
        }

        if(this.allWorkersTasks) {
            this.allTasks = this.allWorkersTasks;
        }

        for (const count in this.ordersStatusCount) {
            this.ordersStatusCount[count] = 0;
        }
        this.allTasks.forEach((task) => {
            if (task.data.status === OrderStatusEnum.ready) {
                this.ordersStatusCount['ready']++;
            }
            if (task.data.status === OrderStatusEnum.atwork) {
                this.ordersStatusCount['atwork']++;
            }
            if (task.data.status === OrderStatusEnum.reject) {
                this.ordersStatusCount['reject']++;
            }
            if (task.data.status === OrderStatusEnum.onway) {
                this.ordersStatusCount['onway']++;
            }
            if (task.data.status === OrderStatusEnum.done) {
                this.ordersStatusCount['done']++;
            }
            if (task.data.status === OrderStatusEnum.destributed) {
                this.ordersStatusCount['destributed']++;
            }
        });
    }

    get orderStatusKeys(): string[] {
        return Object.keys(this.ordersStatusCount);
    }

    ngOnChanges(): void {
        this.calculateStatusOrdersCount();
    }
}
